// src/services/userApi.js
// Servicio para manejar operaciones de usuarios (user.php)

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Lista todos los usuarios
 * GET user.php
 */
export const getUsers = async () => {
  try {
    const response = await dotoniwoofApi.get('/user.php');
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al listar usuarios:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene un usuario por ID (numérico)
 * GET user.php/{id}
 */
export const getUserById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`/user.php/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener usuario:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Obtiene un usuario por email (no numérico)
 * GET user.php/{email}
 * HTTP 204 si no encontrado
 */
export const getUserByEmail = async (email) => {
  try {
    const response = await dotoniwoofApi.get(`/user.php/${encodeURIComponent(email)}`);
    return {
      ok: true,
      status: response.status,
      data: response.data,
      code: response.data?.code
    };
  } catch (error) {
    console.error('Error al obtener usuario por email:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crea un usuario
 * POST user.php
 * Body: firebase_uid, name, email; opcionales: id_role, id_person
 */
export const createUser = async (userData) => {
  try {
    const response = await dotoniwoofApi.post('/user.php', userData);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear usuario:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualiza un usuario
 * PUT user.php/{id} o user.php/{email}
 * Body opcionales: firebase_uid, name, email, id_role, id_person
 */
export const updateUser = async (idOrEmail, userData) => {
  try {
    const path = typeof idOrEmail === 'number' ? idOrEmail : encodeURIComponent(idOrEmail);
    const response = await dotoniwoofApi.put(`/user.php/${path}`, userData);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar usuario:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Elimina un usuario
 * DELETE user.php/{id}
 */
export const deleteUser = async (id) => {
  try {
    const response = await dotoniwoofApi.delete(`/user.php/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar usuario:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
